module.exports = __webpack_public_path__ + "img/calendar-today.d22e989b.svg";